import React from 'react';

import { useGetAnalystFiltersQuery } from '../../../redux/services/AnalystApi';
import { type AnalystFiltersParams } from '../../../redux/types/AnalystTypes';
import { monthStart, previousMonth, today } from '../helpers';
import styles from '../Analyst.module.css';

type Props = {
  value: AnalystFiltersParams;
  onChange: (value: AnalystFiltersParams) => void;
  fields?: Array<'merchant' | 'trader' | 'currency' | 'method'>;
  merchantRequired?: boolean;
};

export const PeriodFilters = ({ value, onChange, fields = ['merchant', 'trader', 'currency', 'method'], merchantRequired }: Props) => {
  const { data: options } = useGetAnalystFiltersQuery();
  const set = (key: keyof AnalystFiltersParams) => (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
    onChange({ ...value, [key]: event.target.value });
  const last = previousMonth();

  return (
    <div className={styles.filters}>
      <label className={styles.field}>
        С
        <input type='date' value={value.date_from || ''} max={value.date_to || undefined} onChange={set('date_from')} />
      </label>
      <label className={styles.field}>
        По
        <input type='date' value={value.date_to || ''} min={value.date_from || undefined} onChange={set('date_to')} />
      </label>
      <button type='button' className={styles.button} onClick={() => onChange({ ...value, date_from: monthStart(), date_to: today() })}>
        Этот месяц
      </button>
      <button type='button' className={styles.button} onClick={() => onChange({ ...value, date_from: last.from, date_to: last.to })}>
        Прошлый месяц
      </button>
      {fields.includes('merchant') && (
        <label className={styles.field}>
          Мерчант
          <select value={value.merchant || ''} onChange={set('merchant')}>
            <option value=''>{merchantRequired ? 'Выберите мерчанта' : 'Все мерчанты'}</option>
            {(options?.merchants || []).map((m) => (
              <option key={m.id} value={m.id}>
                {m.username}
                {m.is_active ? '' : ' (выкл.)'}
              </option>
            ))}
          </select>
        </label>
      )}
      {fields.includes('trader') && (
        <label className={styles.field}>
          Трейдер
          <select value={value.trader || ''} onChange={set('trader')}>
            <option value=''>Все трейдеры</option>
            {(options?.traders || []).map((t) => (
              <option key={t.id} value={t.id}>
                {t.username}
                {t.is_active ? '' : ' (выкл.)'}
              </option>
            ))}
          </select>
        </label>
      )}
      {fields.includes('currency') && (
        <label className={styles.field}>
          Валюта
          <select value={value.currency || ''} onChange={set('currency')}>
            <option value=''>Все валюты</option>
            {(options?.currencies || []).map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </label>
      )}
      {fields.includes('method') && (
        <label className={styles.field}>
          Метод
          <select value={value.method || ''} onChange={set('method')}>
            <option value=''>Все методы</option>
            {(options?.methods || []).map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>
        </label>
      )}
    </div>
  );
};
